/** Port von `IwmDropdownGruppenkennzeichen.razor`. */

import { DropDownList } from '@/components/ui';
import { useGruppenkennzeichen } from '@/hooks/useGruppenkennzeichen';
import type { ChinaAppSysGruppenkennzeichen } from '@/types/entities';
import type { EntityTypes } from '@/types/enums';

export interface GruppenkennzeichenDropdownProps {
  value: string | null;
  onChange(value: string | null): void;
  entity: EntityTypes;
  fieldName: string;
  /** Feste Beschriftung über dem Feld (REQ-24 §2). */
  label?: string;
  readOnly?: boolean;
}

/** Anzeige und Wert sind dasselbe Feld — `DropDownListFieldSettings Value="Value" Text="Value"`. */
const FIELDS = { value: 'Value', text: 'Value' } as const;

export function GruppenkennzeichenDropdown(props: GruppenkennzeichenDropdownProps) {
  const items = useGruppenkennzeichen(props.entity, props.fieldName);

  return (
    <DropDownList<string, ChinaAppSysGruppenkennzeichen>
      value={props.value}
      onChange={(value) => {
        props.onChange(value);
      }}
      items={items}
      fields={FIELDS}
      label={props.label}
      readOnly={props.readOnly}
      showClearButton
    />
  );
}

export default GruppenkennzeichenDropdown;
